import { createTheme } from "@mui/material";

const theme = createTheme({
    // "@global": {
    //   body: {
    //     backgroundColor: 'green'
  
    //   }
   // },
   //HEX-Pri: #007676  rgpa: (0,118,118,1): 
   //Sec1: #fbc628  rgpa: (251, 198,40,1)
   //Sec2: #800000 rgba (128,0,0,1)
   //sec3: #50525e rgba (80, 82,94,1)
   //sec4 #461705 rgba(70, 23,5,1)
    palette: {
      primary: {
        main: "rgba(0, 118, 118, 1)",
        datagridrow: "#00333e",
      },
      secondary: {
        main: "rgba(47, 17, 96, 1)",
      },
      background: {
        paper: "#ffffff",
        default: "#ebebe0",
      },
      dRed: {
        main: "#8b0000",
      },
      lightBlue: {
        main : "#aa97dd",
      },
      bRed: {
        main: "#EE4B2B",
        paperborder: "#ebebe0",
        datagridrowback: "#f5f5f5",
        datagridrow: "#00333e",
        datagridCol: "#608a97"
      },
      brown:"#331a00",
      lightbrown:"#C4A484",
    },
    components: {
      // Name of the component
      MuiContainer: {
        styleOverrides: {
          // Name of the slot
          root: {
            // Some CSS
            backgroundColor: 'white',
          },
        },
      },
    },
  });

  export default theme;